import {Directive, ElementRef} from '@angular/core';
import {Validator, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[emsAlphaNumericSpecialCharacterValidation]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: TextboxPatterncheckDirective, multi: true}
  ]
})
export class TextboxPatterncheckDirective implements Validator {
  newExp: any;

  constructor(public el: ElementRef) {
  }

  validate() {
    this.newExp = new RegExp('^[a-zA-Z0-9+_()\[\\],.\\- ]*$');
    const elementVal = this.el.nativeElement.value;
    if (this.newExp.test(elementVal)) {
      return null;
    } else {
      return {
        appAlphaNumericValidation: false
      };
    }
  }
}
